/** MariaDB/JSON kan returnera is_top_node som 0/1 eller "0"/"1". */
export function isOrgTopNode(
  org: { is_top_node?: boolean | number | string | null } | null | undefined
): boolean {
  if (!org) return false;
  const v = org.is_top_node;
  return v === true || v === 1 || v === '1';
}
